import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SpinnerService } from '../../../services/spinner.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SnackbarService } from '../../../services/snackbar.service';
import { AportacionDIPoseedorControllerService } from 'api-rest';

@Component({
  selector: 'app-holders-contributions-dis-preview-dialog',
  templateUrl: './holders-contributions-dis-preview-dialog.component.html',
  styleUrls: ['./holders-contributions-dis-preview-dialog.component.scss'],
})
export class HoldersContributionsDisPreviewDialogComponent implements OnInit, OnDestroy {

  fileUrl?: SafeResourceUrl;
  fileType?: string;
  tiposFicheroPermitidos = ['application/pdf', 'text/plain'];

  constructor(
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private dialogRef: MatDialogRef<HoldersContributionsDisPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public aportacion: any,
    private sanitizer: DomSanitizer,
    private snackBarSrv: SnackbarService,
    private aportacionDiService: AportacionDIPoseedorControllerService,
  ) {

  }

  ngOnInit() {
    this.cargarDocumento();
  }

  ngOnDestroy() {
    if (this.fileUrl) {
      URL.revokeObjectURL(this.fileUrl as string);
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  cargarDocumento() {
    this.fileType = this.getMimeType(this.aportacion?.documento?.nombre);
    if (this.tiposFicheroPermitidos.includes(this.fileType!) || this.fileType?.startsWith('image/')) {
      this.spinnerSrv.loadingShow();
      this.aportacionDiService.downloadDoc(this.aportacion?.id, 'response').subscribe({
        next: (response) => {
          const blob = new Blob([response.body!], { type: this.fileType });
          const url = URL.createObjectURL(blob);
          this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar('Ha ocurrido un error al cargar el documento.', 'error');
        },
      });
    } else {
      this.snackBarSrv.showSnackBar('No se puede previsualizar el archivo.', 'error');
    }
  }

  getMimeType(filename: string): string {
    const ext = filename.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'pdf': return 'application/pdf';
      case 'txt': return 'text/plain';
      case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'doc': return 'application/msword';
      case 'jpg':
      case 'jpeg': return 'image/jpeg';
      case 'png': return 'image/png';
      
      default: return 'application/octet-stream';
    }
  }

}
